import React from "react";
import PropTypes from "prop-types";
import Icon from "components/icon";
import { withRouter } from "react-router-dom";
/**
 ** WARNING: If we import context or provider directly from "components/router", on import it makes circular dependencies
 **/
import styles from "./styles/back-button.css.js";
import withStyles from "components/with-styles";

const BackButton = ({ classes, history, url }) => {
  return (
    <div
      className={classes.backButton__container}
      onClick={!!url ? () => history.push(url) : () => history.goBack()}>
      <div className={classes.backButton}>
        <Icon className={classes.backButton_icon} name="arrow-back" />
      </div>
    </div>
  );
};

BackButton.propTypes = {
  /**
   * Sobreescribe la url a la que se va al clicar (opcional)
   **/
  url: PropTypes.string,
};

export default withRouter(withStyles(styles)(BackButton));
